import React, { useState, useEffect } from 'react';
import { makeStyles } from '~/UIKit/Style';
import { useMerchantFormGenerator } from './useMerchantFormGenerator';
import { IMerchant, initialValues } from '~/Models/DTO/Merchant.models';
import { ItemCreation, ItemCreationWrapper } from '~/Components';
import { PrivateLayout } from '~/Layout/PrivateLayout';
import { useNavigation } from '~/Hooks';
import { useTranslation } from 'react-i18next';
import { useRequestMerchants } from '~/requests/providerService/useRequestMerchants';
import { useRequestGetMerchantPayoutRates } from '~/requests/providerService/useRequestMerchants/useRequestMerchants';

const useStyles = makeStyles(() => ({
  itemContainer: {
    display: 'block',
    overflow: 'auto',
  },
}));

export const EditMerchant = () => {
  const [merchant, setMerchant] = useState<IMerchant>(initialValues);

  const { classes } = useStyles();
  const { t } = useTranslation();
  const { getParams } = useNavigation();
  const { merchantId } = getParams();
  const { data: rateOptions } = useRequestGetMerchantPayoutRates(merchantId);

  const { sections, validate, onSave, hasErrors, isLoading } = useMerchantFormGenerator({
    merchant,
    merchantId,
    rateOptions,
  });
  const { data } = useRequestMerchants();

  useEffect(() => {
    if (!merchantId) return;
    const merchant = data?.find(({ uuid }: IMerchant) => uuid === merchantId);
    /* istanbul ignore next */
    if (!merchant) {
      return;
    }
    setMerchant(merchant);
  }, [merchantId, data?.length]);

  useEffect(() => {
    const singlePayoutRate = rateOptions?.find((rate: any) => rate.selected);
    if (!!singlePayoutRate) {
      setMerchant((pre) => ({
        ...pre,
        defaultSinglePayoutRate: singlePayoutRate?.value,
      }));
    }
  }, [rateOptions]);

  return (
    <PrivateLayout
      title={t('merchantForm.title')}
      actionDisabled={hasErrors || isLoading}
      actionName={t('app.save')}
      onActionTaken={onSave}
    >
      <div className={classes.itemContainer} data-testid="MerchantForm">
        <ItemCreationWrapper>
          <ItemCreation<IMerchant>
            listItems={sections as any}
            headers={[]}
            onSave={onSave}
            initialValues={merchant}
            validate={validate}
            isLoading={false}
            networkError={undefined}
            validateOnMount
            disableMobile
            skipConfirmationModal
          />
        </ItemCreationWrapper>
      </div>
    </PrivateLayout>
  );
};
